'use strict';
module.exports = require('./BlockUI.vue');